import ls from 'local-storage';
import { PACKAGES_LOCAL_STORAGE_CACHE_KEY } from '../constants/localStorageConstants';
import { setRequestAction } from '../ducks/requestDuck';
import { setFiltersAction } from '../ducks/filtersDuck';
import { validateDateIsAfterToday } from '../utils/dateUtils';

const loadPackagesCacheThunk = () => (dispatch) => {
  const packagesCache = ls.get(PACKAGES_LOCAL_STORAGE_CACHE_KEY);
  if (!packagesCache) {
    return;
  }
  const {
    startLocation,
    endLocation,
    startDate,
    endDate,
    startTime,
    endTime,
    roomsTravelers,
    version,
    timestamp,
    locale,
    countryOfResidence,
    inavLocation,
    ...restOfPackagesSearch
  } = packagesCache;

  dispatch(
    setRequestAction({
      startLocation,
      endLocation,
      startDate: validateDateIsAfterToday(startDate),
      endDate: validateDateIsAfterToday(endDate),
      startTime,
      endTime,
      roomsTravelers,
      countryOfResidence,
      ...restOfPackagesSearch,
    })
  );
  dispatch(
    setFiltersAction({
      ...restOfPackagesSearch,
    })
  );
};

export default loadPackagesCacheThunk;
